import 'mathlive/dist/mathlive-fonts.css';

import './MathField.scss';

import * as React from 'react';

import { MathfieldElement } from 'mathlive';

interface Props {
  latex: string;
  virtualKeyboardMode?: 'manual' | 'onfocus' | 'off';
  defaultMode?: 'math' | 'text';
  onChange?: (latex: string) => void;
  isReadOnly?: boolean;
  autofocus?: boolean;
}

/**
 * `math-live` web component is wrapped in a React component so that it
 * is interacted with in the same manner as a React Component.
 *
 * to expose more features simply expose them as props.
 */
export function MathField({
  latex,
  defaultMode = 'math',
  virtualKeyboardMode,
  onChange,
  autofocus,
}: Props) {
  const [mathField, setMathField] = React.useState<MathfieldElement>();

  React.useEffect(() => {
    if (mathField) {
      mathField.addEventListener('input', (event) => {
        const latex = (event.target as any).getValue('latex-expanded');
        onChange?.(latex);
      });

      mathField.addEventListener('unmount', () => {
        // HACK: On mobile devices the keyboard will show up again when this element is removed.
        mathField.virtualKeyboardState = 'hidden';
      });
    }
  }, [onChange, mathField]);

  React.useEffect(() => {
    if (mathField && autofocus) {
      mathField.focus();
    }
  }, [autofocus, mathField]);

  return (
    <div className="math-container">
      <math-field
        className="math-field"
        virtual-keyboard-mode={virtualKeyboardMode}
        default-mode={defaultMode}
        smart-fence={`${false}`}
        keypress-sound={'none'}
        plonk-sound={'none'}
        ref={setMathField}
      >
        {latex}
      </math-field>
    </div>
  );
}
